export enum InvoicesTableStaticActionType {
  Credit = 'credit',
  Duplicate = 'duplicate',
  RegisterPayment = 'registerPayment',
  Void = 'void',
}
